import { useMemo } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import {
  extractInfoFromInfiniteData,
  extractListRecords,
  extractPropertyFromListRecords,
} from "../utils";
import { handleGetMyFavoriteGames } from "../../api-clients/gamesFavoritesClient";
import { Game } from "@nestcoinco/hyper-api-gateway-api-client";

interface UseInfiniteFavoriteGamesQueryParams {
  enabled?: boolean;
  limit?: number;
  maxPages?: number;
}

function useInfiniteFavoriteGamesQuery(
  params?: UseInfiniteFavoriteGamesQueryParams,
) {
  const { enabled, limit, maxPages } = params || {};

  const query = useInfiniteQuery({
    queryKey: [QUERY_KEYS.GAME.MY_FAVORITE_GAMES],
    queryFn: ({ pageParam }) =>
      handleGetMyFavoriteGames({ page: pageParam, limit }),
    initialPageParam: 1,
    maxPages,
    getNextPageParam: (lastPage) => lastPage.nextPage,
    getPreviousPageParam: (firstPage) => firstPage.previousPage,
    enabled,
  });

  const myFavoriteGamesList = useMemo(
    () => extractInfoFromInfiniteData(query.data),
    [query.data],
  );

  const myFavoriteGames = useMemo(
    () => extractListRecords(myFavoriteGamesList),
    [myFavoriteGamesList],
  );

  const myFavoriteGamesIds = useMemo(
    () => extractPropertyFromListRecords<Game, string>(myFavoriteGames, "id"),
    [myFavoriteGames],
  );

  return { query, myFavoriteGames, myFavoriteGamesIds };
}

export default useInfiniteFavoriteGamesQuery;
